// /src/index.js
import { Buffer } from "buffer";
import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

if (typeof window !== "undefined" && !window.Buffer) {
  window.Buffer = Buffer;
}

// React 18 root render
const root = createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

// Optional: performance reporting
reportWebVitals();